import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertSeverityTypeEnum, AlertTypeEnum, DNATypeEnum, PrimerTypeEnum } from '@shared/enums';
import { OrderDetailsPrimer, OrderDetailsReaction, OrderDetailsRetests, OrderDetailsSample } from '@shared/interfaces';

@Component({
    selector: 'app-order-details',
    standalone: true,
    imports: [TranslateModule, NgClass],
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent {
    readonly samples = input<OrderDetailsSample[]>([]);
    readonly primers = input<OrderDetailsPrimer[]>([]);
    readonly reactions = input<OrderDetailsReaction[]>([]);
    readonly retests = input<OrderDetailsRetests[]>([]);
    readonly id = input<string>('order-details');

    readonly sortedRetests = computed(() => this.retests().sort((a, b) => (a.id < b.id ? 1 : -1)));
    readonly numberOfReactions = computed(() => this.reactions().reduce((acc, value) => acc + value.primers.length, 0));
    readonly retestReactionsNumbers = computed(() =>
        this.retests().map(retest => retest.reactions.reduce((acc, reaction) => acc + reaction.primers.length, 0))
    );

    readonly alertSeverityTypes = AlertSeverityTypeEnum;
    readonly alertTypes = AlertTypeEnum;
    readonly dnaTypes = DNATypeEnum;
    readonly primerTypes = PrimerTypeEnum;
}
